module.exports = __webpack_public_path__ + "media/images/icons/code-8437b0d3a638471174ecb985696c8585.svg";